var _ = require('underscore');
var $ = require('jquery');

/**
 * Product excluder class
 */
function ProductExcluder(exclusions) {

    /** @var {Object} */
    this.currentConfiguration = {};

    /** @var {Array} */
    this.exclusions = exclusions;

    /**
     * Set current product's configuration
     * @param configuration
     */
    this.setCurrentConfiguration = function(configuration)
    {
        this.currentConfiguration = configuration;
    }

    /**
     * Get current product's configuration
     */
    this.getCurrentConfiguration = function()
    {
        return this.currentConfiguration;
    }

    /**
     * Get excluded fields for given type and id base on current configuration
     * @param {String} type
     * @param {number} id
     */
    this.getExcludedItems = function(id)
    {
        var excluded = [];
        var exclusions = this.exclusions;
        var currentConfiguration = this.simplifyExclusion(this.getCurrentConfiguration());
        for (var i in exclusions)
        {
            var exclusion = this.simplifyExclusion(exclusions[i]);
            var diff = $(exclusion).not(currentConfiguration).get();
            if(diff.length == 1) {
                excluded.push(diff[0]);
            } else if(diff.length == 0) {
                excluded.push(id);
            }
        }
        return excluded;
    }

    /**
     * Simplify given exclusion as non-assoc array
     * @param exclusion
     * @returns {Array}
     */
    this.simplifyExclusion = function(exclusion)
    {
        var simplified = [];
        for (var i in exclusion) {
            if(i !== 'id') {
                simplified.push(exclusion[i]);
            }
        }
        return simplified;
    }
}

/**
 * Exclusions applier class
 */
function ExclusionsDOMApplier() {

    this.allowedNames = [
        'material',
        'print',
        'sides',
        'size',
        'other'
    ];

    /** @var {Array} Array of currently disabled DOM elements */
    this.currentlyDisabled = [];

    /**
        * Initial method
        * @param {Array} exclusions
        */
    this.init = function(exclusions) {
        this.excluder = new ProductExcluder(exclusions);
        this.prepareFieldsEvents();
        var fields = this.getFields();

        for (let i in fields) {
            $(fields[i]).change();
        }

        // After first initial change of fields some of selected options can be disabled
        // and therefore can be wrong displayed so reset of selections is needed
        for (let i in fields) {
            var field = fields[i];
            if($(field).is('select') && $(field).val() === null) {
                $(field).find('option:enabled:first').prop('selected', true);
            }
        }
    }

    /**
        * Get current product's configuration of attributes
        * from DOM's fields structure
        */
    this.getCurrentConfiguration = function()
    {
        var configuration = {};
        var fields = this.getFields();
        var otherIndex =  1;
        for (var i in fields) {
            var field = fields[i];
            var value = $(field).val();
            var key = this.getFieldType(field);
            if(key == 'other') {
                key += otherIndex++;
                value = $(field).is(':checked') ? value : null;
            }
            if(value) {
                configuration[key] = parseInt(value);
            }
        }
        return configuration;
    }

    /**
        * Prepare fields events
        */
    this.prepareFieldsEvents = function()
    {
        var _this = this;
        $.each(this.getFields(), function(index, field) {
            $(field).change(function() {
                _this.excluder.setCurrentConfiguration(
                    _this.getCurrentConfiguration()
                )
                var excluded = _this.excluder.getExcludedItems(
                    $(field).val()
                );
                _this.applyExclusions(excluded);
            })
        })
    }

    /**
        * Get fields needed for exclusion
        */
    this.getFields = function() {
        if(!this.fields) {
            this.fields = [];
            for (var j in this.allowedNames) {
                var name = this.allowedNames[j];
                var field = $('[name*="order[' + name + ']"');
                if($(field).is('input[type=checkbox]')) {
                    var _this = this;
                    $.each(field, function (key, checkbox) {
                        _this.fields.push(checkbox);
                    })
                } else if ($(field).is('select')) {
                    this.fields.push(field);
                }
            }
        }
        return this.fields;
    }

    /**
        * Apply exclusions on DOM
        * @param {Array} excluded
        */
    this.applyExclusions = function(excluded)
    {
        this.resetDisabled();
        for (var i in excluded) {
            var excludedId = excluded[i];
            var fields = this.getFields();
            for (var j in fields) {
                var field = fields[j];
                if($(field).is('select')) {
                    var optionForDisable = this.getSelectOptionByValue(field, excludedId);
                    if(optionForDisable.length) {
                        optionForDisable
                            .attr('disabled', true)
                            .attr('selected', false);
                        this.addCurrentlyDisabled(optionForDisable);
                    }
                } else if($(field).is('input[type=checkbox]') && $(field).attr('value') == excludedId) {
                    $(field).attr('checked', false);
                    $(field).attr('disabled', true);
                    this.addCurrentlyDisabled(field);
                }
            }
        }
    }

    /**
        * Add DOM object to currently disabled
        */
    this.addCurrentlyDisabled = function(domObject)
    {
        this.currentlyDisabled.push(domObject);
    }

    /**
        * Reset currently disabled array
        */
    this.resetDisabled = function() {
        for (var i in this.currentlyDisabled) {
            $(this.currentlyDisabled[i]).attr('disabled', false);
        }
        this.currentlyDisabled = [];
    }

    /**
        * Find <option/> for given <select/> by value
        */
    this.getSelectOptionByValue = function(select, value)
    {
        var option;
        if($(select).is('select')) {
            option = $(select).children('option[value='+ value +']');
        } else {
            throw new Error('Given field is not select type');
        }

        return option;
    }

    /**
        * Get field's type
        * @param {Object}field
        * @returns {String}
        */
    this.getFieldType = function(field)
    {
        var name = $(field).attr('name');
        return name.match(/order\[(\w+)\]/)[1];
    }
}

$(document).ready(function() {
    if (!_.isUndefined(hasExclusions) && hasExclusions) {
        var exclusionsDOMApplier = new ExclusionsDOMApplier();
        exclusionsDOMApplier.init(exclusions);
    }
});
